import { createApi } from '@reduxjs/toolkit/query/react'
import baseQuery from '../baseQuery'

export const apiEmailOptOutSlice = createApi({
  reducerPath: 'emailOptOutApi',
  baseQuery,
  tagTypes: ['emailOptOut'],
  endpoints: (builder) => ({
    getEmailOptOut: builder.query({
      query: (secureToken: string) => ({
        url: `/api/emailOptOut/${secureToken}`,
      }),
    }),
  }),
})

export const {
  useLazyGetEmailOptOutQuery,
  useGetEmailOptOutQuery,
} = apiEmailOptOutSlice
